module.exports = __webpack_public_path__ + "static/media/iPhone14-4.98b174a7.png";